var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Organisations 🚀"}},[_c('b-card-text',[_vm._v(" An organisation represents a company or grouping using the Secris system. This section is for Secris staff only. ")])],1),_c('organisations')],1)}
var staticRenderFns = []

export { render, staticRenderFns }